import { App, default as AppDefault } from './App';

export {
  App,
};
export default AppDefault;